// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fh","advertDetailHeaderLocation__value":"c-m_fi"};